// src/app/services/config.service.ts
import { Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '@app/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public readonly config: WritableSignal<{
    UmbracoApiBaseUrl: string;
    ChallengeEUAPIBaseUrl: string;
    UmbracoBasicAuthHttpHeaderName: string;
    UmbracoBasicAuthHttpHeaderValue: string;
    EnvironmentName: string;
  }> = signal({
    UmbracoApiBaseUrl: environment.viceNewRestAPI,
    ChallengeEUAPIBaseUrl: environment.viceNewGraphQlAPI,
    UmbracoBasicAuthHttpHeaderName: 'X-Authentication-Shared-Secret',
    UmbracoBasicAuthHttpHeaderValue: environment.viceNewRestAPISecret,
    EnvironmentName: environment.envName,
  })


  setConfig(config: any) {
    if (config) {
      const patched = {
        ...config,
        UmbracoApiBaseUrl: config.UmbracoApiBaseUrl.replace('/api', ''),
      };
      console.debug('ConfigService: Setting config', patched);
      this.config.set(patched);
    }
  }

  getConfig() {
    return this.config;
  }
}
